import itemsData from '@/data/items.json';

interface ItemTpl {
  id: number;
  icon?: string;
  type: string;
  effect?: string;
}
const TPL: Record<number, ItemTpl> = Object.fromEntries(
  (itemsData.items as ItemTpl[]).map((i) => [i.id, i]),
);

function fallbackColor(tpl: ItemTpl | null | undefined): string {
  if (!tpl) return '#9aa';
  switch (tpl.type) {
    case 'consumable': return tpl.effect === 'mana' ? '#3498db' : '#e74c3c';
    case 'scroll': return '#f1c40f';
    case 'petbox': return '#9b59b6';
    case 'weapon': return '#e67e22';
    case 'armor': return '#95a5a6';
    case 'shield': return '#7f8c8d';
    case 'material': return '#2ecc71';
    default: return '#cfd8dc';
  }
}

function fallbackGlyph(tpl: ItemTpl | null | undefined): string {
  if (!tpl) return '?';
  switch (tpl.type) {
    case 'consumable': return tpl.effect === 'mana' ? 'M' : 'H';
    case 'scroll': return 'S';
    case 'petbox': return 'P';
    case 'weapon': return 'W';
    case 'armor': return 'A';
    case 'shield': return 'D';
    case 'material': return 'J';
    default: return '*';
  }
}

interface ItemIconProps {
  templateId: number;
  size?: number;
}

export function ItemIcon({ templateId, size = 32 }: ItemIconProps) {
  const tpl = TPL[templateId];
  const iconName = tpl?.icon;

  if (iconName) {
    return (
      <img
        src={`/assets/items/${iconName}.png`}
        alt={iconName}
        style={{
          width: size,
          height: size,
          imageRendering: 'pixelated',
          objectFit: 'contain',
        }}
        draggable={false}
      />
    );
  }

  // Fallback to glyph if no icon asset
  return (
    <div style={{
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size * 0.55,
      fontWeight: 'bold',
      color: fallbackColor(tpl),
      lineHeight: '1',
    }}>
      {fallbackGlyph(tpl)}
    </div>
  );
}
